import { RecordCard } from '../../../../store/shared/RecordCard';
import { observer } from 'mobx-react';
import { getCardLink } from '../utils';
import { TelegramButton } from './TelegramButton';
import { VKButton } from './VKButton';
import { OkButton } from './OkButton';

import './style.scss';

interface ShareTabProps {
  card: RecordCard;
}

export const ShareTab = observer(({ card }: ShareTabProps) => {
  const { tableName, recordId } = card;
  const layerName = card.connectedLayer.layerName;

  const url = getCardLink({
    tableName,
    recordId: '' + recordId,
    layerName,
  });

  const title = encodeURIComponent(card.cardInfo.name);
  const url_share = encodeURIComponent(url);

  const tgUrl = `https://t.me/share/url?url=${url_share}&text=${title}`;
  const vkUrl = `https://vk.ru/share.php?url=${url_share}&title=${title}`;
  const okUrl = `https://connect.ok.ru/offer?url=${url_share}&title=${title}`;

  return (
    <div className="share-card-tab">
      <div className="social-network-list">
        <TelegramButton url={tgUrl}>Поделиться в Телеграм</TelegramButton>

        <VKButton url={vkUrl}>Поделиться в ВК</VKButton>

        <OkButton url={okUrl}>Поделиться в Одноклассниках</OkButton>
      </div>
    </div>
  );
});
